import { FACET_DELIMITER } from '@/components/ui/SearchResults/constants';
import {
  LIBRARY_FILTERS,
  LibraryFilterValue,
  QuickFilter,
  SuggestedFacet
} from './libraryConstants';
import { LibraryResponse } from '@/@types/client-api';
import { FilterProps } from '@/components/ui/Filter/types';

export const isItemChecked = (
  itemValue?: LibraryFilterValue,
  selectedValue?: LibraryFilterValue
) => {
  if (typeof selectedValue === 'string') {
    return selectedValue.split(FACET_DELIMITER).includes(itemValue as string);
  }

  return selectedValue === itemValue;
};

export const getOnlyActiveTabLabel = (data: LibraryResponse | null): string | undefined => {
  const tabData = Object.entries(data?.summary?.headerGroupSearchableTypeCounters || []);
  const activeTabs = tabData.filter(([_, count]) => count);

  if (activeTabs.length === 2) {
    // length is 2 to account for "All" tab
    return activeTabs.find(([label]) => label !== 'All')?.[0];
  }
};

export const getFilters = (
  filters: FilterProps[],
  suggestions: SuggestedFacet[]
): QuickFilter[] => {
  return filters
    .filter(group => group.groupTypeId !== LIBRARY_FILTERS.GROUP_SEARCHABLE_TYPE)
    .flatMap(group =>
      group.items
        .filter(
          item =>
            // Quick filters are a mix of selected filters...
            item.checked ||
            // ...and suggested filters
            suggestions.some(s => s.value === item.value && s.group === group.groupTypeId)
        )
        .map(item => ({
          data: {
            label: item.label,
            checked: item.checked,
            value: item.value,
            groupTypeId: group.groupTypeId
          },
          canDeselect: true
        }))
    )
    .filter(Boolean);
};
